import React, { ChangeEvent, FC, useEffect } from "react";
import { message } from "antd";
import useGlobalModel from "../../model/globalModel";
import { useHistory } from "react-router-dom";
import "./Login.scss";
import { loginService } from "./LoginService";
import { loginServiceAuth2, Auth2MenuDetail } from "./LoginServiceAuth2";
import { globalPrompt } from "@/components/message";
import { SmileTwoTone } from "@ant-design/icons";
import { CLIENT_APP_CODE } from "@/utils/constants";
// import { defaultMdCmParam } from "@/utils/constants";
// import { shopService } from "../organization/shop/shopService";

interface ITokenLogin {
	token: string;
}
declare const window: Window & { loginTimer: NodeJS.Timeout | null };

//初始页数
const searchParams = { pageSize: 999999, pageNum: 1 }

export const TokenLogin: FC<ITokenLogin> = ({ token }) => {
	const history = useHistory()
	const { user, setUser, setBeShopDs, setShopAndOrg, setResourceAuth, setShopDs, setMenuAuth, setAuthRoleIdList } = useGlobalModel();

	useEffect(() => {
		if (!window.loginTimer) {
			window.loginTimer = setTimeout(function () { beforeLogin() }, 1500);
		}
	}, [])
	//设置用户菜单和资源列表
	let IsystemCode: any = {
		"TEST": "vrm-sa",
		"TESTNGA": "vrm-nga",
		"PROD": "vrm-sa",
		"PRODNGA": "vrm-nga"
	}
	let shopAndOrgParams: any = {
		"TEST": {
			shopId: "8eeae6a7c92c0e9274a0e98afd43ffbf",
			shopName: "沙特海外门店",
			shopCode: "SHOP-M-00000011"
			// bentityCode: "Nor Motor Co.,Ltd."
			// bentityName: "沙特NOR MOTORS"
		},
		"PROD": {
			shopId: "8eeae6a7c92c0e9274a0e98afd43ffbf",
			shopName: "沙特海外门店",
			shopCode: "SHOP-M-00000011"
			// bentityCode: "Nor Motor Co.,Ltd."
			// bentityName: "沙特NOR MOTORS"
		},
	}
	const beforeLogin = async () => {
		const REACT_APP_ENV = process.env.REACT_APP_ENV as string
		let systemCode = IsystemCode[REACT_APP_ENV]
		let { retData, retMsg, retCode } = await loginServiceAuth2.VerifyInfo({ sourceApp: systemCode, token });
		let { menus, resources, roles, shops, ...userInfo } = retData ?? {};
		setAuthRoleIdList(resources)
		let menuArr: string[] = [];
		function findMenuAll(array: Auth2MenuDetail[]) {
			array.forEach(item => {
				item.linkUrl && menuArr.push(item.linkUrl);
				if (item.children && item.children.length > 0)
					findMenuAll(item.children);
			})
		}
		findMenuAll(menus?.[systemCode] ?? []);
		setMenuAuth(menuArr)
		console.log(retData)
		if (retCode == "200") {
			setUser({ ...user, token, username: userInfo.userName, ...userInfo, shopCode: shopAndOrgParams[REACT_APP_ENV]["shopCode"], loginType: 'token', })
			setShopAndOrg(shopAndOrgParams[REACT_APP_ENV])
			globalPrompt("notification", {
				type: "success", title: "登录成功",
				duration: 3,
				text: <p className="bold"><span className="block"><SmileTwoTone /> {`您好!${userInfo.userName ?? ""}`}</span>欢迎使用云豪沙特管理系统</p>
			});
			loginServiceAuth2.recordAppLoginInfo(CLIENT_APP_CODE, userInfo.userCode);
			history.push('/');
		}
		// let userInfo: object = {};
		//拿到用户信息
		// await loginService.getUser().then(result => {
		// 	if (result.retCode === '200') {
		// 		// console.log(result.retData)
		// 		userInfo = result.retData;
		// 		// history.push('/')
		// 	} else {
		// 		message.warning("获取用户信息失败");
		// 		return;
		// 	}
		// });
		//设置用户门店信息
		// await shopService.page({ page: searchParams, sourceApp: defaultMdCmParam.sourceApp }).then(async res => {
		// 	if (res.retData && res.retData.records && res.retData.records.length > 0) {
		// 		let shop = res.retData.records[0];
		// 		// setUser({ ...user, ...userInfo, token, shopId: shop.id, shopName: shop.name, loginType: 'token' });
		// 		// debugger;
		// 		//设置对应门店下面的实体 缓存
		// 		let { retData } = await shopService.one({
		// 			sourceApp: "scm",
		// 			branch: "main",
		// 			code: shop.code
		// 		});
		// 		let { details } = retData;

		// 		if (details && details.length) {
		// 			setBeShopDs(details.map(item => ({
		// 				id: item.id,
		// 				label: item.bentityName ?? "",
		// 				value: item.bentityCode ?? ""
		// 			})));
		// 		}
		// 		history.push('/');
		// 	}
		// })
	}


	return (
		<div className="login">
			<div className="caseBlanche">
				<div className="rond">
					<div className="test"></div>
				</div>
				<div className="load">
					<p>loading</p>
				</div>
			</div>
		</div>
	)

}

export default TokenLogin;